module.exports = __webpack_public_path__ + "img/1aa7f28.png";